import type { EquipSpecialAttrType } from '@/types/equip'
import type { EquipAffixType } from '@/types/equip-affix'
// 取消使用完就销毁的效果，除了百分比率扣血和点名秒杀的效果
// UI上显示技能名字，同名叠加效果和减少冷却
export const equipAffixCollectionRogue: EquipAffixType = {
  thump: {
    name: '重击',
    desc: ({ rate, value, multiplier }) => {
      return `<span class="info">主动使用</span> 可进行一次攻击并造成 <span class="grow">200%</span> 的伤害，冷却时间 <span class="info">10</span> 秒，收集多个重击可缩短冷却时间`
    },
  },
  harvest: {
    name: '收割',
    desc: ({ hpPercent, value, multiplier }) => {
      return `<span class="info">主动使用</span> 可进行一次攻击并造成敌方已损失生命值 <span class="grow">10%</span> 的伤害，冷却时间 <span class="info">45</span> 秒，收集多个收割可缩短冷却时间`
    },
  },
  assault: {
    name: '冲锋',
    desc: ({ hpPercent, value, multiplier }) => {
      return `<span class="info">主动使用</span> 可进行一次攻击并造成敌方当前生命值 <span class="grow">10%</span> 的伤害，冷却时间 <span class="info">45</span> 秒，收集多个冲锋可缩短冷却时间`
    },
  },
  chasing: {
    name: '追击',
    desc: ({ value }) => {
      return `攻击命中时有 <span class="info">10%的概率</span> 追加一次攻击，收集多个追击可略微提升追击概率`
    },
  },
  heavyInjury: {
    name: '重创',
    desc: ({ value }) => {
      return `<span class="info">主动使用</span> 可进行一次攻击，若此次攻击暴击则造成 <span class="grow">300%</span> 的伤害，冷却时间 <span class="info">10</span> 秒，收集多个重创可提升伤害`
    },
  },
  break: {
    name: '破阵',
    desc: ({ multiplier }) => `攻击力提高 <span class="grow">10%</span>`,
  },
  crushBone: {
    name: '碎骨',
    desc: ({ rate, value, multiplier }) => {
      return `攻击时无视敌方 <span class="grow">20%</span> 的防御，最高叠加100%`
    },
  },
  burst: {
    name: '爆发',
    desc: ({ rate }) => {
      return `<span class="info">主动使用</span> 可进行一次暴击攻击，冷却时间 <span class="info">10</span> 秒，收集多个爆发可缩短冷却时间`
    },
  },
  nothingness: {
    name: '虚无',
    desc: ({ rate }) => `<span class="info">主动使用</span> 可进行一次攻击并造成敌方最大生命值 <span class="grow">8%</span> 的伤害，冷却时间 <span class="info">60</span> 秒，收集多个虚无可提升效果`
  },
  split: {
    name: '分裂',
    desc: ({ rate, value }) => {
      return `攻击命中时有 <span class="info">5%</span> 的概率分裂出额外两段攻击，收集多个分裂可略微提升分裂概率`
    },
  },
  cruel: {
    name: '残忍',
    desc: ({ value, multiplier }) => {
      return `暴击时无视敌方 <span class="grow">30%</span> 的防御，最高叠加100%。`
    },
  },
  shadowBlade: {
    name: '影刃',
    desc: ({ value, multiplier }) => {
      return `攻击时附加敌方当前生命值 <span class="grow">0.1%</span> 的 <span class="real-damage">真实伤害</span>`
    },
  },
  swiftness: {
    name: '轻灵',
    desc: ({ value }) => {
      return `额外攻击速度增加 <span class="grow">0.2</span> 倍`
    },
  },
  sharp: {
    name: '锋利',
    desc: ({ multiplier }) => {
      return `攻击时，附加 <span class="grow">20%</span> 的伤害`
    },
  },
  precise: {
    name: '精准',
    desc: ({ rate, value, multiplier }) => {
      return `<span class="info">主动使用</span> 可进行一次必定命中的攻击，冷却时间 <span class="info">5</span> 秒，收集多个精准可缩短冷却时间`
    },
  },
  rout: {
    name: '击溃',
    desc: ({ value, multiplier }) => {
      return `击杀敌人后，可增加 <span class="grow">1</span> 点攻击力`
    },
  },
  tearInjury: {
    name: '裂创',
    desc: ({ value }) => {
      return `攻击命中时，有 <span class="info">3%</span> 的概率削减敌方当前生命值 <span class="grow">20%</span>（对领主的效果只有1/6），收集多个裂创可略微提升概率`
    },
  },
  impact: {
    name: '冲击',
    desc: ({ hpPercent, value, multiplier }) => {
      return `<span class="info">主动使用</span> 可进行一次攻击并造成敌方当前生命值 <span class="grow">10%</span> 的伤害，冷却时间 <span class="info">45</span> 秒，收集多个冲击可提升效果`

    },
  },
  windUp: {
    name: '收尾',
    desc: ({ hpPercent, value, multiplier }) => {
      return `<span class="info">主动使用</span> 可进行一次攻击并造成敌方已损失生命值 <span class="grow">10%</span> 的伤害，冷却时间 <span class="info">45</span> 秒，收集多个收尾可提升效果`

    },
  },
  swanElegy: {
    name: '噩兆',
    desc: () => '敌方血量低于 <span class="info">10%</span> 时，必定暴击，收集多个噩兆可提升触发阈值',
  },
  lucky7: {
    name: '幸运7',
    desc: ({ rate }) => `幸运提升7点`,
  },
  drawChop: {
    name: '拔刀斩',
    desc: ({ atkPercent }) => `<span class="info">主动使用</span> 必定命中，造成 <span class="grow">700%</span> 的伤害，冷却时间 <span class="info">60</span> 秒，收集多个拔刀可缩短冷却时间`,
  },
  onikiri: {
    name: '鬼斩',
    desc: ({ rate }) => `<span class="info">主动使用</span> 移除敌方 <span class="grow">50%</span> 的最大生命值，使用后装备消失`,
  },
  longYa: {
    name: '暴虐',
    desc: ({ percent }) => `<span class="info">70%</span> 的破防转换为攻击，收集多个暴虐可提升转换效果`,
  },
  desolator: {
    name: '黯灭',
    desc: ({ crtd }) => '将自身 <span class="info">50%</span> 的暴击率加成转化为暴击伤害，收集多个黯灭可提升转换效果',
  },
  gentle: {
    name: '温柔一刀',
    desc: () => '<span class="info">主动使用</span> 造成 <span class="grow">百倍破防</span> 的伤害，冷却时间 <span class="info">90</span> 秒，收集多个温柔一刀可缩短冷却时间',
  },
  nightingale: {
    name: '夜莺',
    desc: () => '获得等同于 <span class="info">暴击率</span> 的 <span class="info">攻击</span>',
  },
  balance: {
    name: '神圣平衡',
    desc: () => '未实现',
  },
  pity: {
    name: '怜悯',
    desc: ({ value }) => `命中率固定为 <span class="info">90%</span>`,
  },
  parocheth: {
    name: '帷幕',
    desc: () => '敌方血量低于 <span class="info">10%</span> 时，必定命中，收集多个帷幕可提升触发阈值',
  },
  selectiveExpansion: {
    name: '更多选择',
    desc: () => `解锁第四个战利品选项`,
  },
  upgradeLoot: {
    name: '升级再升级',
    desc: () => '提升战利品品质',
  },
  recoverHp: {
    name: '西瓜疗法',
    desc: ({ value, value2 }) =>
      `持有时最大生命力提高 <span class="grow">${value2}</span> 点，使用时回复最多 <span class="grow">${value}</span> 点生命力`,
  },
  moreExp: {
    name: '更多经验',
    desc: ({ value }) => `经验获取提高 <span class="grow">${10 * value}%</span>（最低1点）`,
  },
  moreGold: {
    name: '更多金币',
    desc: ({ value }) => `金币获取提高 <span class="grow">${10 * value}%</span>`,
  },
}
export function explainEquipAffixRogue(affixList: EquipSpecialAttrType[]) {
  return affixList.map((item) => {
    const equipAffix = equipAffixCollectionRogue[item.key]
    const name = equipAffix?.name ?? '未知'
    const desc = equipAffix?.desc(item.data) ?? '未实现'
    return `<span class="special">${name}</span>：${desc}`
  })
}